import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import PerformanceMonitor from "@/components/PerformanceMonitor";

import Index from "./pages/Index";
import Documentation from "./pages/Documentation";
import Cobranca from "@/pages/usecases/Cobranca";

import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const LayoutWithConditionalFooter = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const location = useLocation();
  const isDocumentationPage = location.pathname.startsWith("/documentation");

  return (
    <>
      <Navbar />
      {children}
      {!isDocumentationPage && <Footer />}
    </>
  );
};

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <PerformanceMonitor />
      <Toaster />
      <Sonner />

      <BrowserRouter>
        <LayoutWithConditionalFooter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/documentation/:slug?" element={<Documentation />} />
            <Route path="/usecases/cobranca" element={<Cobranca />} />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </LayoutWithConditionalFooter>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
